import axios from 'axios';

// Use relative URL in production (same domain), absolute URL in development
const API_URL = process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_BACKEND_URL || '');
const api = axios.create({ baseURL: `${API_URL}/api` });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

export const authApi = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  me: () => api.get('/auth/me'),
  updateMe: (data) => api.put('/auth/me', data),
  changePassword: (data) => api.post('/auth/change-password', data),
  changeEmail: (data) => api.put('/auth/change-email', data),
  exportData: () => api.get('/auth/me/export'),
  deleteAccount: () => api.delete('/auth/me'),
};

export const adminApi = {
  listUsers: () => api.get('/admin/users'),
  updateUser: (id, data) => api.put(`/admin/users/${id}`, data),
  deleteUser: (id) => api.delete(`/admin/users/${id}`),
};

export const propertiesApi = {
  list: () => api.get('/properties'),
  get: (id) => api.get(`/properties/${id}`),
  create: (data) => api.post('/properties', data),
  update: (id, data) => api.put(`/properties/${id}`, data),
  delete: (id) => api.delete(`/properties/${id}`),
  downloadPdf: (id) => api.get(`/properties/${id}/pdf`, { responseType: 'blob' }),
  downloadOfferPdf: (id) => api.get(`/properties/${id}/pdf/offer`, { responseType: 'blob' }),
};

export const publicApi = {
  submitAnalysis: (data) => api.post('/public/analysis', data),
  getAnalysis: (id, edit = false) => api.get(`/public/analysis/${id}${edit ? '?edit=true' : ''}`),
  saveDraft: (data, draftId) => api.post(`/public/analysis/draft${draftId ? `?draft_id=${draftId}` : ''}`, data),
  finalizeDraft: (draftId) => api.put(`/public/analysis/${draftId}/finalize`),
};

export const settingsApi = {
  get: () => api.get('/settings'),
  update: (data) => api.put('/settings', data),
  getThresholds: () => api.get('/settings/thresholds'),
  getThresholdsList: () => api.get('/settings/thresholds-list'),
  getRepairItems: () => api.get('/settings/repair-items'),
  getCostEstimates: () => api.get('/settings/cost-estimates'),
  getModernizationItems: () => api.get('/settings/modernization-items'),
  getHistoryItems: () => api.get('/settings/history-items'),
  getAssessmentLabels: () => api.get('/settings/assessment-labels'),
  getHomepageText: () => api.get('/settings/homepage-text'),
  getSeoSection: () => api.get('/settings/seo-section'),
  getMetaTags: () => api.get('/settings/meta-tags'),
  getEquipmentItems: () => api.get('/settings/equipment-items'),
};

export const privacyApi = {
  get: () => api.get('/privacy-policy'),
  update: (data) => api.put('/privacy-policy', data),
};

export default api;
